export const EXPERIMENT_VALUES = {};

type Experiments = {
  [key: string]: boolean | string;
};

export const EXPERIMENT_DEFAULT_VALUES: Experiments = {
  noFreeTrials: false,
};

// This need to be in sync with src/common/scss/variables.scss
export const BREAKING_POINTS = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
};

export const EMAIL_ADDRESSES = {
  sales: 'sales@streamable.com',
  support: 'support@streamable.com',
};

export const SOCIAL_MEDIA_LINKS = {
  twitter: 'https://twitter.com/streamable',
};

export const ONETRUST_SCRIPT_CATEGORIES = {
  technical: 'optanon-category-C0001',
  analytics: 'optanon-category-C0002',
  functional: 'optanon-category-C0003',
  profiling: 'optanon-category-C0004',
  socialmedia: 'optanon-category-C0005',
};
